export default {
    policyTransactions: (state) => (policy) => {
        return state.transactions.find((pol) => {
            if (pol.key === policy.value) {
                return pol;
            }
        });
    },
};
